<main class="container-fluid px-0 pb-3 pb-lg-5">

  <div class="px-3 py-2 py-md-0 bg-darkest">
    <div class="container-lg">
      <div class="d-flex align-items-center justify-content-between">
        <h1 class="h3 fw-bold mb-0">{{ (userHasTracker ? 'CATEGORIES.RECOMMENDED2' : 'CATEGORIES.RECOMMENDED' )| translate}}</h1>
        <div class="category-icon-overlay">
          <img [src]="'assets/icons/most_played_big.svg'" alt="category background image" width="100%">
        </div>
      </div>
    </div>
  </div>

  <div class="container-lg">
    <div class="px-0 mt-0 mt-md-4">
      <!--      games -->
      <div *ngIf="recommendedGames && recommendedGames.length; else noMatchBlock " class="pt-3">
        <div class="row row-cols-3 row-cols-md-4 row-cols-lg-6 g-2 g-sm-3 g-md-4">
          <div class="col" *ngFor="let g of recommendedGames">
            <app-game-item [game]="g" [favouriteIds]="favouriteIds"></app-game-item>
          </div>
        </div>
      </div>

      <ng-template #noMatchBlock>
        <div class="container text-center pt-5">
          <h3>{{'HOME.NOGAMES_MESSAGE' | translate}}</h3>
          <h4>{{'HOME.NOGAMES_TIP' | translate}}</h4>
        </div>
      </ng-template>
    </div>
  </div>

  <div class="mt-4">
    <app-providers-carousel></app-providers-carousel>
    <app-carousel [dataList]="randomGamesForCarousel" [identifier]="'all'"></app-carousel>
  </div>

</main>
